import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Response } from '../models/Response';
import { Paginator } from '../models/Paginator';
import {
  EmailLog,
  SendIndividualEmailRequest,
  SendBulkEmailRequest,
} from '../models/Email';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private apiUrl = `${environment.API_URL}/email`;

  constructor(private http: HttpClient) {}

  // ========== EMAIL SENDING ==========

  sendIndividual(data: SendIndividualEmailRequest): Observable<Response<EmailLog>> {
    return this.http.post<Response<EmailLog>>(`${this.apiUrl}/send-individual`, data);
  }

  sendBulk(data: SendBulkEmailRequest): Observable<Response<EmailLog>> {
    return this.http.post<Response<EmailLog>>(`${this.apiUrl}/send-bulk`, data);
  }

  // ========== EMAIL HISTORY ==========

  getHistory(
    page: number = 1,
    perPage: number = 10,
    filters?: any,
    dateFrom?: string,
    dateTo?: string
  ): Observable<Response<Paginator<EmailLog>>> {
    let params = new HttpParams()
      .set('page', page.toString());

    if (filters) {
      params = params.set('filters', JSON.stringify(filters));
    }

    if (dateFrom) {
      params = params.set('date_from', dateFrom);
    }

    if (dateTo) {
      params = params.set('date_to', dateTo);
    }

    return this.http.get<Response<Paginator<EmailLog>>>(
      `${this.apiUrl}/history/${perPage}`,
      { params }
    );
  }

  getEmailDetails(id: number): Observable<Response<EmailLog>> {
    return this.http.get<Response<EmailLog>>(`${this.apiUrl}/show/${id}`);
  }

  retryEmail(id: number): Observable<Response<EmailLog>> {
    return this.http.post<Response<EmailLog>>(`${this.apiUrl}/retry/${id}`, {});
  }
}
